<template>
  <span>
    <!-- Filtro Custom -->
    <div class="d-flex align-items-center">
        <v-select
          ref="SelectFiltroCustom"
          v-model="filtroCustom"
          v-b-tooltip.hover
          class="selectFiltro flex-grow-1 pr-1 max-select"
          :options="opcoesFiltrosCustom"
          clearable
          label="nome"
          placeholder="Filtros"
          @input="executarFiltro()"
        >
          <!-- <template #option="{ label }">            Pega prop label do objeto-->
          <template
            #option="{ nome, cor }"
          >
            <b-badge
              pill
              :style="`background-color:${cor};`"
            >
              <!-- variant="light-primary" -->
              {{ nome }}
            </b-badge>
          </template>

          <!-- template para caso não tiver opções -->
          <template slot="no-options">
            <span>Nenhum filtro cadastrado</span>
          </template>

        </v-select>

        <div @click="abrirEditFiltro()">
          <feather-icon
            icon="EditIcon"
            class="text-primary cursor-pointer"
            size="15"
          />
        </div>

    </div>
    <!-- Fim select -->

    <b-modal
      ref="modalFiltroCustom"
      size="xl"
      no-close-on-backdrop
      :hide-header-close="true"
      @hide="onHide"
    >
      <b-row style="margin-bottom: 5%;margin-top: 1%;">
        <b-col cols="3">
          <b-form-group
            label="Nome Filtro"
          >
            <v-select
              id="nomeFiltroInput"
              :ref="`SelectFiltros`"
              :value="filtroSelect"
              :options="opcoesFiltrosCustom"
              clearable
              label="nome"
              deselect-from-dropdown
              placeholder="Filtros"
              @input="onTrocarFiltro"
            >

              <template
                #option="{ nome, cor }"
              >
                <b-badge
                  pill
                  :style="`background-color:${cor};`"
                >
                  {{ nome }}
                </b-badge>
              </template>

              <!-- template para caso não tiver opções -->
              <template slot="no-options">
                <span>Nenhum filtro cadastrado</span>
              </template>

            </v-select>
          </b-form-group>
        </b-col>

        <b-col
          cols="1"
          style="margin-top: 30px;"
          @click="$refs.colorSelect.onShow()"
        >
          <feather-icon
            id="filtroColor"
            v-b-tooltip.hover
            :title="filtroSelect.id ? 'Alterar' : 'Novo'"
            :icon="filtroSelect.id ? 'EditIcon' : 'PlusIcon'"
            class="text-secondary cursor-pointer"
            size="30"
          />
        </b-col>

        <b-col cols="3">
          <small
            class="text-danger alinhar-cifrao"
            style="left: 78px;"
          >*</small>
          <b-form-group
            label="Usuários"
          >
            <v-select
              :ref="`SelectUsers`"
              v-model="filtroSelect.usuarios"
              v-b-tooltip.hover
              :options="usuarios"
              :clearable="true"
              label="nome"
              :disabled="!filtroSelect.nome || filtroSelect.nome == ''"
              multiple
              deselect-from-dropdown
              placeholder="Usuários"
              @input="marcarComoAlterado"
            />

            <small
              v-if="filtroSelect.filtrosDocs && !filtroSelect.usuarios.length > 0"
              class="text-danger"
            >Usuários é obrigatório
            </small>

          </b-form-group>
        </b-col>

        <b-col cols="4">
          <small
            class="text-danger alinhar-cifrao"
            style="left: 170px;"
          >*</small>
          <b-form-group
            label="Tipos de documentos"
          >
            <v-select
              :ref="`SelectDocs`"
              v-model="filtrosDocsVisual"
              v-b-tooltip.hover
              :options="opcoesDocsPermitidas"
              :clearable="true"
              :disabled="!filtroSelect.nome || filtroSelect.nome == ''"
              multiple
              deselect-from-dropdown
              placeholder="Documentos"
              @input="mudarDocs"
            />

            <small
              v-if="filtroSelect.filtrosDocs && !filtroSelect.filtrosDocs.length > 0"
              class="text-danger"
            >Tipos de documentos é obrigatório
            </small>

          </b-form-group>
          <div style="display: flex; align-items: center; margin-top: 5px;">
            <b-form-checkbox
              v-model="filtroSelect.comHistorico"
              value="true"
              unchecked-value="false"
              :disabled="!filtroSelect.nome"
              @input="marcarComoAlterado"
            >
              Incluir histórico
            </b-form-checkbox>
            <feather-icon
              v-b-tooltip.hover
              title="Ao selecionar, o sistema trará também os dados dos históricos, podendo aumentar o tempo de download"
              icon="InfoIcon"
              class="text-primary"
              style="margin-left: 8px;"
            />
          </div>
        </b-col>
        <b-col
          cols="1"
          class="d-flex align-items-start"
          style="padding-top: 2.5rem;"
        >
          <feather-icon
            icon="TrashIcon"
            :class="{
              'text-danger cursor-pointer': !!filtroSelect.nome,
              'text-muted cursor-not-allowed': !filtroSelect.nome,
            }"
            size="20"
            style="line-height: 1;"
            @click.stop="filtroSelect.nome && remover()"
          />
        </b-col>
      </b-row>

      <template #modal-title>
        <h3>Cadastrar filtros especiais</h3>
        <fieldset class="font-weight-bold text-muted small">
          Crie filtros personalizados, informando usuário, tipo de documento e empresa para cada filtro.
        </fieldset>
      </template>
      <template #modal-footer>
        <b-btn
          variant="none"
          size="sm"
          class="btn-outline-success btn-none"
          style="margin-left: 0.3rem;"
          :disabled="desabledSalvar"
          @click="salvar(true)"
        >
          Salvar
        </b-btn>
        <b-btn
          variant="none"
          size="sm"
          class="btn-outline-danger btn-none"
          style="margin-left: 0.3rem;"
          @click="cancelar()"
        >
          Cancelar
        </b-btn>
      </template>

      <vinculo-empresas
        v-if="!!filtroSelect.nome"
        ref="vinculoEmpresa"
        v-model="empresasVinculadas"
        :cadastro-usuario="false"
        :visualizacao-opcoes="visualizacao"
        :tem-busca="true"
        :filtros-vinculadas="filtrosVinculadas"
        :filtros-nao-vinculadas="filtrosNaoVinculadas"
        :quantidade="45"
      />

      <color-select
        ref="colorSelect"
        v-model="filtroSelect"
        :api="api"
        @criar="criarFiltro($event)"
        @atualizar="atualizarFiltro"
      />
    </b-modal>
  </span>
</template>

<style lang="scss">
.v-select:not(.vs--single) .vs__selected {
    font-size: 0.8rem;
}
.alinhar-cifrao {
  position: absolute;
  top: auto;
}

// Controle de largura e altura dos v-selects
.selectFiltro {
  min-width: 200px;
  max-width: 100%;

  .vs__dropdown-toggle {
    min-height: 38px;
    max-height: 38px;
    overflow: hidden;
  }

  .vs__selected-options {
    flex-wrap: nowrap;
    overflow: hidden;
  }

  .vs__selected {
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    margin: 2px;
  }

  .vs__search {
    margin: 4px 0;
  }
}

// Estilo específico para os v-selects dentro da modal
#nomeFiltroInput,
#baixaPortalSelect {
  .vs__dropdown-toggle {
    min-height: 38px;
    max-height: 38px;
    overflow: hidden;
  }

  .vs__selected-options {
    flex-wrap: nowrap;
    overflow: hidden;
  }

  .vs__selected {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
  }
}

// Para v-selects múltiplos
.v-select.vs--multiple {
  .vs__dropdown-toggle {
    min-height: 38px;
    max-height: 60px; // Permite até 2 linhas
    overflow-y: auto;
  }

  .vs__selected-options {
    max-height: 56px;
    overflow-y: auto;
    flex-wrap: wrap;
  }

  .vs__selected {
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 2px;
  }
}

// Menu dropdown com largura controlada
.vs__dropdown-menu {
  max-width: 350px;

  .vs__dropdown-option {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>

<script>

import vSelect from 'vue-select'
import Vue from 'vue'

export default {
  name: 'FiltroCustom',
  components: {
    VinculoEmpresas: () => import('@pilar/components/vinculo-empresas/VinculoEmpresas.vue'),
    ColorSelect: () => import('./ColorSelectFiltro.vue'),
    vSelect,
  },
  props: {
    filtrosDefaultDocs: {
      type: Array,
      default: null,
    },
    api: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filtroCustom: null,
      filtroOriginal: null,
      proximoFiltro: null,
      temAlteracoesPendentes: false,
      opcoesFiltrosCustom: [],
      opcoesFiltrosCustomImutavel: [],
      desabledSalvar: false,
      filtrosRapidosDocs: this.filtrosDefaultDocs,
      usuarios: [],
      empresas: [],
      filtroSelect: {
        nome: '', usuarios: [], filtrosDocs: [], empresas: { vinculadas: [], naoVinculadas: [] }, comHistorico: false,
      },
      empresasVinculadas: {
        vinculadas: [],
        naoVinculadas: [],
        id: 0,
      },
      filtrosVinculadas: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial'], valor: null }],
      filtrosNaoVinculadas: [{ colunas: ['CadastroFederalSemMascara', 'CadastroFederal', 'RazaoSocial'], valor: null }],
      visualizacao: {
        placeholderBusca: 'Busca por palavra chave e CNPJ/CPF',
        tituloVinculada: 'Empresas Vinculadas',
        tituloDesvinculada: 'Empresas Desvinculadas',
        customTitle: 'Seleção de Empresas',
        customSubtitle: 'Selecione as empresas que deseja vincular neste filtro',
        evento: this.getTotalEmpresasFiltrado,
      },
      MapaDocsPermissao: {
        'situacao fiscal': 'situacaofiscal_federal',
        'cnd rfb/pgfn': 'cnd_federal',
        'cnd fgts': 'cnd_fgts',
        'cnd trabalhista': 'cnd_trabalhista',
        'cnd estadual': 'cnd_estadual',
        'cnd municipal': 'cnd_municipal',
        'declaracao dctfweb': 'declaracao_dctfweb',
        das: 'das',
        sublimite: 'sublimite',
        'parcelamento pgfn': 'pgfn_parcelamento',
        'parcelamento das': 'das_parcelamento',
        'parcelamento relp': 'parcelamento_relpsn',
        'parcelamento rfb': 'parcelamento_rfb',
        'parcelamento pert': 'parcelamento_pertsn',
        'parcelamento nao previdenciario': 'parcelamento_naoprevidenciario',
        'parcelamento simplificado previdenciario': 'parcelamento_simp_previdenciario',
      },
    }
  },
  computed: {
    filtrosDocsVisual: {
      get() {
        if (!Array.isArray(this.filtroSelect.filtrosDocs)) return []

        return this.filtroSelect.filtrosDocs
          .filter(doc => this.filtrosRapidosDocs.includes(doc))
          .filter(doc => this.documentosPermitidosUsuario.includes(doc))
      },
      set(valorVisual) {
        const docsNaoVisiveis = this.filtroSelect.filtrosDocs.filter(
          doc => !this.filtrosRapidosDocs.includes(doc) || !this.documentosPermitidosUsuario.includes(doc),
        )

        this.filtroSelect.filtrosDocs = [
          ...docsNaoVisiveis,
          ...valorVisual,
        ]
      },
    },
    documentosPermitidosUsuario() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      const acessos = userData?.ability || []

      return this.filtrosDefaultDocs.filter(doc => {
        const chave = this.normalizarDoc(doc)
        const permissao = this.MapaDocsPermissao[chave]

        if (chave === 'todos') return true
        if (!permissao) return false

        return acessos.some(a => a.subject === permissao)
      })
    },
    opcoesDocsPermitidas() {
      // se estiver no modo "Todos"
      if (this.filtrosDocsVisual.includes('Todos')) {
        return ['Todos']
      }

      return this.filtrosRapidosDocs.filter(
        doc => this.documentosPermitidosUsuario.includes(doc),
      )
    },
  },
  watch: {
  },
  created() {
    this.carregarFiltroResumido()
  },
  methods: {
    getDocsParaSalvar() {
      const temTodos = this.filtroSelect.filtrosDocs?.includes('Todos')

      if (temTodos) {
        this.filtroSelect.filtrosDocs = this.filtrosDefaultDocs.filter(f => f !== 'Todos')
      }
    },
    normalizarDoc(doc) {
      return doc
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    },
    onTrocarFiltro(novoFiltro) {
      if (novoFiltro?.id === this.filtroSelect?.id) return

      if (!this.temAlteracoesPendentes) {
        this.validarFiltro(novoFiltro)
        return
      }

      this.proximoFiltro = novoFiltro

      this.mostrarConfirmacaoAlteracoes()
    },
    descartarAlteracoes() {
      if (!this.filtroSelect?.id) {
        this.opcoesFiltrosCustom = JSON.parse(JSON.stringify(this.opcoesFiltrosCustomImutavel))
      }
      this.temAlteracoesPendentes = false
      this.validarFiltro(this.proximoFiltro)
      this.proximoFiltro = null
    },
    mostrarConfirmacaoAlteracoes() {
      Vue.swal({
        title: 'Alterações não salvas',
        html: '<p>Você possui alterações não salvas no filtro atual.</p><p class="text-muted">Deseja salvar as alterações antes de continuar?</p>',
        icon: 'warning',
        showDenyButton: true,
        confirmButtonText: 'Salvar e Continuar',
        denyButtonText: 'Descartar Alterações',
        customClass: {
          confirmButton: 'btn btn-outline-success mr-50',
          denyButton: 'btn btn-outline-danger mr-50',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(result => {
        if (result.isConfirmed) {
          this.salvar()
        } else if (result.isDenied) {
          this.descartarAlteracoes()
        }
      })
    },
    salvarEstadoOriginal() {
      this.filtroOriginal = JSON.parse(JSON.stringify({
        ...this.filtroSelect,
        empresas: this.empresasVinculadas,
      }))

      this.temAlteracoesPendentes = false
    },
    marcarComoAlterado() {
      if (!this.filtroOriginal) return

      const filtroAtual = {
        ...this.filtroSelect,
        empresas: this.empresasVinculadas,
      }

      this.temAlteracoesPendentes = JSON.stringify(this.filtroOriginal) !== JSON.stringify(filtroAtual)
    },
    executarFiltro() {
      this.$emit('aplicarFiltro', this.filtroCustom)
    },
    abrirEditFiltro() {
      this.carregarFiltro()
      this.$refs.modalFiltroCustom.show()
    },
    validarFiltro(filtro) {
      if (!filtro) {
        this.filtroSelect = {
          nome: '',
          usuarios: [],
          filtrosDocs: [],
          empresas: { vinculadas: [], naoVinculadas: [] },
          comHistorico: false,
        }
      }

      if (filtro?.id) {
        this.api.getFiltroCustomById(filtro.id)
          .then(({ data }) => {
            this.filtroSelect = data
            this.empresasVinculadas = data.empresas
            this.carregarUsuarios()
            this.salvarEstadoOriginal()
          }).catch(() => {
            this.$erro('Erro ao carregar o filtro selecionado')
          })
      }
    },
    mudarDocs(docs) {
      this.marcarComoAlterado()
      if (docs && docs.find(find => find === 'Todos')) {
        this.filtrosRapidosDocs = ['Todos']
        this.filtroSelect.filtrosDocs = ['Todos']
      } else {
        this.filtrosRapidosDocs = this.filtrosDefaultDocs
      }
    },
    carregarFiltro() {
      if (this.filtroCustom) {
        this.api.getFiltroCustomById(this.filtroCustom.id)
          .then(({ data }) => {
            this.filtroSelect = data
            this.empresasVinculadas = data.empresas
            this.carregarUsuarios()
            this.salvarEstadoOriginal()
          }).catch(() => {
            this.$erro('Erro ao carregar o filtro selecionado')
          })
      }
    },
    carregarFiltroResumido() {
      this.api.getFiltroCustomResumido()
        .then(({ data }) => {
          this.opcoesFiltrosCustom = JSON.parse(JSON.stringify(data))
          this.opcoesFiltrosCustomImutavel = JSON.parse(JSON.stringify(data))
        }).catch(err => {
          this.$erro('Erro ao carregar os filtros', 'danger')
          throw err
        })
    },
    carregarUsuarios() {
      this.api.getUsuariosFiltro()
        .then(payload => {
          if (payload) {
            this.usuarios = payload.data
          }
        })
    },
    carregarEmpresas() {
      this.api.getTotalEmpresas()
        .then(({ data }) => {
          this.empresasVinculadas = data
        })
        .catch(() => {
          this.$erro('Não foi possível buscar as empresas')
        })
    },
    getTotalEmpresasFiltrado(id, body) {
      return this.api.getTotalEmpresasFiltrado(body)
    },
    cancelar() {
      this.opcoesFiltrosCustom = JSON.parse(JSON.stringify(this.opcoesFiltrosCustomImutavel))
      this.filtroSelect = {}
      this.empresasVinculadas = {
        vinculadas: [],
        naoVinculadas: [],
        id: 0,
      }
      this.temAlteracoesPendentes = false
      this.filtroOriginal = null
      this.$refs.modalFiltroCustom.hide()
    },
    remover() {
      if (!this.filtroSelect.id > 0) {
        this.$erro('Filtro inválido')
      } else {
        this.$confirmar('Remover?', 'Tem certeza que deseja remover esse filtro?', 'warning', true)
          .then(result => {
            if (result.value) {
              this.api.deleteFiltroCustom(this.filtroSelect.id)
                .then(() => {
                  this.$sucesso('Removido')
                  this.opcoesFiltrosCustom.splice(this.opcoesFiltrosCustom.findIndex(filtro => filtro.id === this.filtroSelect.id), 1)
                  this.opcoesFiltrosCustomImutavel = JSON.parse(JSON.stringify(this.opcoesFiltrosCustom))

                  this.temAlteracoesPendentes = false
                  this.filtroOriginal = null

                  this.filtroSelect = {
                    nome: '',
                    usuarios: [],
                    filtrosDocs: [],
                    empresas: { naoVinculadas: [], vinculadas: [] },
                    comHistorico: false,
                  }
                })
                .catch(err => {
                  this.$erro('Não foi possível remover as informações')
                  throw err
                })
            }
          })
      }
    },
    salvar(fecharModal = false) {
      if (this.filtroSelect && this.filtroSelect.nome && this.filtroSelect.usuarios.length > 0 && this.filtroSelect.filtrosDocs.length > 0) {
        this.desabledSalvar = true
        this.filtroSelect.empresas = this.empresasVinculadas
        this.getDocsParaSalvar()

        this.api.salvarFiltroCustom(this.filtroSelect)
          .then(({ data }) => {
            const index = this.opcoesFiltrosCustom.findIndex(
              f => f.nome === data.nome,
            )
            this.opcoesFiltrosCustom.splice(index, 1, data)
            this.opcoesFiltrosCustomImutavel = JSON.parse(JSON.stringify(this.opcoesFiltrosCustom))

            if (this.filtroSelect.id === this.filtroCustom?.id) {
              this.filtroCustom = data
              this.executarFiltro()
            }

            if (fecharModal) {
              this.hide()
            } else {
              this.temAlteracoesPendentes = false

              if (this.proximoFiltro) {
                this.validarFiltro(this.proximoFiltro)
                this.proximoFiltro = null
              }

              this.salvarEstadoOriginal()
            }

            this.$sucesso('Filtro salvo com sucesso')
          })
          .finally(() => {
            this.desabledSalvar = false
          })
      } else {
        this.$erro('Preencha os campos corretamente', 'danger')
      }
    },
    criarFiltro(filtro) {
      const filtroNew = {
        ...filtro,
        filtrosDocs: [],
        usuarios: [],
      }
      this.carregarEmpresas()
      this.carregarUsuarios()
      this.salvarEstadoOriginal()
      this.opcoesFiltrosCustom.push(filtroNew)
      this.filtroSelect = filtroNew
    },
    atualizarFiltro(filtro) {
      const index = this.opcoesFiltrosCustom.findIndex(f => f.id === filtro.id)
      if (index !== -1) {
        this.$set(this.opcoesFiltrosCustom, index, filtro)
      }
    },
    show() {
      this.desabledSalvar = false
      this.$refs.modalFiltroCustom.show()
    },
    hide() {
      this.$refs.modalFiltroCustom.hide()
    },
    onHide() {
      this.cancelar()
    },
  },
}
</script>
